import { httpClient } from '../Common/api/http_client';

export const geoCodeAddress = async (address) => {
  const newAddress = address.replace(/\s/g, '+');
  const response = await httpClient.get(`https://cors-anywhere.herokuapp.com/https://maps.googleapis.com/maps/api/geocode/json?address=${newAddress}&key=${process.env.VUE_APP_GOOGLE_API_KEY}`);
  return response.results[0].geometry.location;
};
